/**
 * Tiny CSV helpers for the admin tables. `toCsv` is pure (unit-tested);
 * `downloadCsv` triggers a browser download of the built string.
 */

type Cell = string | number | null | undefined;

/** RFC-4180-ish: quote any cell containing a comma, quote, or newline. */
export function toCsv(headers: string[], rows: Cell[][]): string {
  const esc = (v: Cell): string => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  return [headers, ...rows].map((row) => row.map(esc).join(',')).join('\r\n');
}

/** Build a CSV string and download it as `filename`. */
export function downloadCsv(filename: string, headers: string[], rows: Cell[][]): void {
  const blob = new Blob([toCsv(headers, rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
